import * as React from 'react';
import Svg, {SvgProps, Circle, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={93}
    height={87}
    viewBox={'0 0 93 87'}
    {...props}
    fill="none"
    stroke="none">
    <Circle cx={33.943} cy={36.829} r={6.829} fill={props.fill || '#99004D'} />
    <Circle cx={79} cy={27} r={13} fill={props.fill || '#99004D'} />
    <Path
      fill={props.fill || '#99004D'}
      fillRule="evenodd"
      d="M32.551 49.439a1.836 1.836 0 0 0-3.239-.781l-2.702 3.407c-1.851 2.333-4.82 3.437-7.787 3.172A64.548 64.548 0 0 0-3.42 57.141c-34.532 9.114-55.137 44.496-46.023 79.028 9.115 34.531 44.497 55.136 79.028 46.022 34.532-9.114 55.137-44.496 46.023-79.028C70.38 83.362 56.518 68.14 39.13 60.475c-2.896-1.277-5.13-3.778-5.75-6.882l-.829-4.154Z"
      clipRule="evenodd"
    />
    <Circle
      cx={21.547}
      cy={4.548}
      r={3.491}
      fill={props.fill || '#99004D'}
      transform="rotate(-22.09 21.547 4.548)"
    />
  </Svg>
);
export default SvgComponent;
